import useFeatureFlags from 'common/hooks/useFeatureFlags';
import useUser from 'common/hooks/useUser';

export const useIsSharedMenuGoogleSheetsEnabled = () => {
  const { isEmployee, user } = useUser();

  const { data: featureFlags, isInitialLoading } = useFeatureFlags(
    ['enable_shared_menu_google_sheets'],
    {
      user_id: user?.id || '',
    },
    { enabled: isEmployee },
  );

  return {
    isSharedMenuGoogleSheetsEnabled: !isEmployee ? false : !!featureFlags?.enable_shared_menu_google_sheets,
    isSharedMenuGoogleSheetsEnabledLoading: isInitialLoading,
  };
};
